import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-9734">
      <PaymentForm data-id="element-9735" />
    </div>;
}